import DataUsageIcon from '@mui/icons-material/DataUsage';
import GroupIcon from '@mui/icons-material/Group';
import SettingsIcon from '@mui/icons-material/Settings';
import PersonIcon from '@mui/icons-material/Person';
import DevicesIcon from '@mui/icons-material/Devices';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

export const navItems = [
  { key: 'overview', title: 'layout.dashboard_text', /*href: paths.dashboard.overview,*/ icon: <DataUsageIcon />, path: '/', staff_only: false },
  { key: 'account', title: 'layout.account_text', /*href: paths.dashboard.account,*/ icon: <PersonIcon />, path: '/account', staff_only: false },
]


export const staffNavItems = [
  { key: 'devices', title: 'layout.devices_text', /*href: paths.dashboard.devices,*/ icon: <DevicesIcon />, path: '/devices', staff_only: true },
  { key: 'users', title: 'layout.users_text', /*href: paths.dashboard.customers,*/ icon: <GroupIcon />, path: '/users', staff_only: true },
  { key: 'settings', title: 'layout.settings_text', /*href: paths.dashboard.settings,*/ icon: <SettingsIcon />, staff_only: true },
  { key: 'help', title: 'layout.help_text', /*href: paths.dashboard.help,*/ icon: <HelpOutlineIcon />, path: '/help', staff_only: false },
]